import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Breadcrumbs from '../../../../layout/components/Breadcrumbs';
import Text from '../../../../components/Text/Text';
import Button from '../../../../components/Button/Button';
import ButtonTypes from '../../../../constants/buttonTypes';
import orderedPartsStatus from '../../../../constants/orderedPartsStatus';
import { setOrderedPartsFilter } from '../../../../actions/coilovers/orderedParts/orderedPartsFilter';
import getOrderedParts from '../../../../thunks/coilovers/orderedParts/getOrderedParts';
import { permissions } from '../../../../common/permissionGroup';
import { IconFileExport, IconPlus, IconSetting } from '../../../../assets/icon';
import PermissionsGate from '../../../../components/PermissionsGate/PermissionsGate';
import OrderedPartsNewModal from './OrderedPartsNewModal';
import TableSettingModal from '../../../../components/TableSettingModal/TableSettingModal';
import { coOrderedPartsTable } from '../../../../constants/coOrderedPartsTable';
import { setApplicationState } from '../../../../actions/application/application';
import toggleArrayItem from '../../../../helpers/toggleArrayItem';
import Badge from '../../../../components/Badge/Badge';
import DownloadFileModal from '../../../../components/DownloadFileModal/DownloadFileModal';
import downloadFilesType from '../../../../constants/downloadFilesType';

const subheaderClassName = 'flex items-center border-t border-[#eff2f5] dark:border-[#1b263b] px-[25px] h-full';
const breadcrumbsClassName = 'py-[5px]';
const titleClassName = 'text-text-second text-[13px] mr-[10px]';
const badgeClassName = 'p-[5px]';
const buttonClassName = 'px-[13px] py-[8px] mr-[5px]';
const dividerClassName = 'w-[1px] bg-[#eff2f5] dark:bg-[#1b263b] mx-[17px]';

const OrderedPartsSubheader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeButton, setActiveButton] = useState('');
  const [newModalVisible, setNewModalVisible] = useState(false);
  const [downloadModalVisible, setDownloadModalVisible] = useState(false);
  const [tableSettingModalVisible, setTableSettingModalVisible] = useState(false);

  const {
    orderedPartsFilter,
    orderedPartsFilter: { partStatus },
    application: { orderedPartsTableSetting },
    getOrderedParts: {
      total
    }
  } = useSelector((state) => ({
    orderedPartsFilter: state?.orderedPartsFilter,
    application: state?.application,
    getOrderedParts: state?.getOrderedParts
  }), shallowEqual);

  const breadcrumbs = {
    pageTitle: 'Ordered parts',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'Coilovers',
      },
      {
        title: 'Ordered parts',
      },
    ]
  };

  useEffect(() => {
    if (partStatus && partStatus?.length === 1 && partStatus?.[0] === orderedPartsStatus.ON_THE_WAY) {
      setActiveButton(orderedPartsStatus.ON_THE_WAY);
    } else {
      setActiveButton('');
    }
  }, [partStatus]);

  const onTheWay = () => {
    dispatch(setOrderedPartsFilter({
      partStatus: [
        orderedPartsStatus.ON_THE_WAY,
      ],
      page: 1
    }));
    dispatch(getOrderedParts());
  };

  return (
    <div className={subheaderClassName}>
      <div className="flex-1">
        <Breadcrumbs breadcrumbs={breadcrumbs} containerStyle={breadcrumbsClassName} />
      </div>
      <div className="flex flex-row justify-end">
        <div className="flex flex-row items-center">
          <Text text="Filtered:" textStyle={titleClassName} />
          <Badge
            text={`${total}${total >= 10000 ? '+' : ''}`}
            type={ButtonTypes.LIGHT_INFO}
            containerStyle={badgeClassName}
          />
        </div>
        <div className={dividerClassName} />
        <div className="flex flex-row">
          <Text bold text="Filter By:" textStyle={titleClassName} />
          <Button
            text="On the way"
            type={activeButton === orderedPartsStatus.ON_THE_WAY ? ButtonTypes.LIGHT_SUCCESS : ButtonTypes.ACTIVE_LIGHT}
            containerStyle={buttonClassName}
            onClick={onTheWay}
          />
        </div>
        <div className={dividerClassName} />
        <PermissionsGate can={permissions.COW_CREATE}>
          <Button
            type={ButtonTypes.LIGHT_SUCCESS}
            icon={<IconPlus />}
            onClick={() => setNewModalVisible(true)}
            containerStyle={buttonClassName}
            tooltip="Add new order"
            tooltipId="orderedPartsAddNew"
          />
        </PermissionsGate>
        <Button
          type={ButtonTypes.LIGHT}
          icon={<IconFileExport />}
          containerStyle={buttonClassName}
          tooltip="Click to download"
          tooltipId="orderedPartsExportTable"
          onClick={() => setDownloadModalVisible(true)}
        />
        <Button
          type={ButtonTypes.LIGHT}
          icon={<IconSetting />}
          containerStyle={buttonClassName}
          tooltip="Table settings"
          tooltipId="orderedPartsTableSettings"
          onClick={() => setTableSettingModalVisible(true)}
        />
      </div>
      <OrderedPartsNewModal
        visible={newModalVisible}
        toggleVisible={() => setNewModalVisible(false)}
      />
      <TableSettingModal
        title="Ordered Parts Table Setting"
        visible={tableSettingModalVisible}
        toggleVisible={() => setTableSettingModalVisible(false)}
        list={coOrderedPartsTable}
        values={orderedPartsTableSetting}
        onSelect={(val) => dispatch(setApplicationState({
          orderedPartsTableSetting: toggleArrayItem(orderedPartsTableSetting, val)
        }))}
      />
      <DownloadFileModal
        visible={downloadModalVisible}
        toggleVisible={() => setDownloadModalVisible(false)}
        type={downloadFilesType.ORDERED_PARTS}
        filter={orderedPartsFilter}
      />
    </div>
  );
};

OrderedPartsSubheader.propTypes = {};

OrderedPartsSubheader.defaultProps = {};

export default OrderedPartsSubheader;
